<template>
	<!-- <div class="newpage">
		<div class="printTest-box">
			<div id="printTest">
				<div style="display: flex;flex-direction: column;align-items: center;">
					<loading class="loading_style" :tip="tip" v-if="!th_printdata.length"></loading>
					<div ref="menuItem" v-else>
						<div class="pro_total" v-for="(item, index) in arr" :key="index">
							<div style="width:100%">
								<div v-if="index == 0"
									style="display:flex;border-bottom: 1px #000000 solid;padding-bottom: 2px ;text-align: center;font-size: 14px;width:100%">
									<span style="display: inline-block;width: 40px;">#</span>
									<span style="display: inline-block;width: 115px;">Order NO.</span>
									<span style="display: inline-block;width: 120px;">p_sku</span>
									<span style="display: inline-block;width: 120px;">{{ userId ==
										'ST1kevin985517@gmail.com' ? 'v_name' : 'w_sku' }}</span>
									<span style="display: inline-block;width: 120px;">img</span>
									<span style="display: inline-block;flex:1;">Qty</span>
								</div>
								<div style="display:flex;align-items: center;font-size: 10px;text-align: center; padding: 3px 0;width:100%"
									v-for="(ccp, index01) in item.itemsCopy" :key="index01">
									<span style="display: inline-block;width: 40px;" v-if="index01 < 5">{{
										getIndex(index, index01) }}</span>
									<span style="display: inline-block;width: 115px;" v-if="index01 < 5">{{
										item.orderId }}</span>
									<div style="flex: 1;" v-if="index01 < 5">
										<div style="display:flex;align-items: center;border-bottom: 1px solid #E0E0E0;"
											v-for="(oop, index03) in ccp" :key="index03">
											<div style="width:120px;word-break:break-all">{{ oop.itemSku }}
											</div>

											<div style="width:120px;word-break:break-all;">{{
												userId
												== 'ST1kevin985517@gmail.com' ? oop.variationName :
												oop.skuName }}</div>
											<img style="width:120px;display: block;margin: 0 auto;min-height: 120px;"
												:src="oop.image" />
											<div style="flex:1;font-size: 16px;">{{ oop.rate *
												oop.purchaseNum
											}}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div style="flex: 1;">
			<div style="height: 200px;">
				<el-button style="margin: 20px 0 0 30px;" type="primary" v-print="'#printTest'">{{
					$t('other.a342') }}</el-button>
			</div>
		</div>

	</div> -->

	<div class="pick-list-box">
		<div class="top-header">
			<el-button size="mini" type="primary" v-print="'#printTest'" @click="addPrintNum()">{{ $t('other.a342')
			}}</el-button>
		</div>
		<div id="printTest">
			<div>
				<div class="pick-list-wrpper">
					<loading class="loading_style" :tip="tip" v-if="!th_printdata.length"></loading>
					<div class="print-area" v-else>
						<div
							style="display: flex;justify-content: flex-start;border-bottom: 1px solid #000;font-weight: bold;text-align: center;">
							<span style="display: inline-block;width: 40px;">#</span>
							<span style="display: inline-block;width: 240px;">Order NO.</span>
							<span style="display: inline-block;width: 120px;">p_sku</span>
							<span style="display: inline-block;width: 120px;">{{ userId ==
								'ST1kevin985517@gmail.com' ? 'v_name' : 'w_sku' }}</span>
							<span style="display: inline-block;width: 120px;">img</span>
							<span style="display: inline-block;flex:1;">Qty</span>
						</div>
						<div v-for="(item, index) in arr" :key="index">
							<div ref="box"
								style="display:flex;align-items: center;font-size: 10px;text-align: center; padding: 3px 0;width:100%"
								v-for="(ccp, index01) in item.itemsCopy" :key="index01">
								<span style="display: inline-block;width: 40px;">{{
									getIndex(index, index01) }}</span>
								<span style="display: inline-block;width: 240px;"
									v-if="item.itemsCopy.length <= 1">{{
										item.orderId }}<span v-if="item.distributeStatus&&item.distributeStatus!=0" style="color: #67C23A;">(销)</span>
									<img style="width: 100%;display: flex;justify-content: center;" class="barcodeDiv"
										:id="'barcode_' + getIndex(index, index01)"></img>
										<span>运单号：{{ item.trackingNo?item.trackingNo:'暂无' }}</span>
								</span>
								<span style="display: inline-block;width: 240px;"
									v-if="item.itemsCopy.length > 1">{{
										item.orderId }}-{{ index01 + 1 }}(Total {{item.itemsCopy.length}} Pcs)<span v-if="item.distributeStatus&&item.distributeStatus!=0" style="color: #67C23A;">(销)</span>
									<img style="width: 100%;display: flex;justify-content: center;" class="barcodeDiv"
										:id="'barcode_' + getIndex(index, index01)"></img>
										<span>运单号：{{ item.trackingNo?item.trackingNo:'暂无' }}</span>
								</span>
								<div style="flex: 1;">
									<div style="display:flex;align-items: center;border-bottom: 1px solid #E0E0E0;"
										v-for="(oop, index03) in ccp" :key="index03">
										<div style="width:120px;word-break:break-all">{{ oop.itemSku }}
										</div>

										<div style="width:120px;word-break:break-all;">{{
											userId
											== 'ST1kevin985517@gmail.com' ? oop.variationName :
											oop.skuName }}</div>
										<img style="width:120px;display: block;margin: 0 auto;min-height: 120px;"
											:src="oop.ZHUImg" />
										<div style="flex:1;font-size: 16px;">{{ oop.rate *
											oop.purchaseNum
										}}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

				</div>

			</div>
		</div>
	</div>
</template>
<script>
import QRCode from 'qrcodejs2'
import JsBarcode from 'jsbarcode'
import utils from '../../../../utils/utils'
import printApi from '../../../../api/moudles/print.js'
import api from '../../../../api/api'
import newOrderApi from '../../../../api/moudles/newOrders'
import orderApi from '../../../../api/moudles/order'
import loading from '../../../../components/loading_2.vue'
import sellerPurchaseApi from '../../../../api/moudles/sellerpurchase'




import {
	mapState,
	mapMutations,
	mapActions,
} from 'vuex'

import pdf from 'vue-pdf'

export default {
	data() {
		return {
			useraddress: '',
			qrcodeImg: '',
			userId: JSON.parse(localStorage.getItem('userInfo')).userId,
			th_printdata: [],
			barcodeValue: 123,
			orderList: [],
			storeItemList: [],
			tip: this.$t('other.a500'),
			arr: [],
			orderId: '',
			trackingNo: '',
			value: 3,
			checked: false,
			value: '10',
			loadingList: [],
			loadedList: [],
			currentPage2: 1,
			pageSize: 10,
			chooseList: null,
			generateOrderId: []

		}
	},
	components: {
		loading,
		pdf


	},
	computed: {
		...mapState({
			picklist: state => state.order.picklist,
			seller: state => state.login.userInfo.userId,
			buttonMapList: state => state.print.buttonMapList,
			toPrintOrders: state => state.common.toPrintOrders,
		}),



		listCopy() {
			if (this.checked) {
				let list = this.th_printdata
				let list2 = list.slice((this.currentPage2 - 1) * this.pageSize, (this.currentPage2) * this.pageSize)
				console.log(list2)

				this.chooseList = list2
				return list2
			} else {
				return this.th_printdata
			}
		},


	},
	watch: {
		listCopy() {
			console.log(this.listCopy)
		},
		storeItemList() {
			let list = this.orderList
			let storeItem = this.storeItemList

			list.forEach(p => {
				p.items.forEach(i => {
					i.storeItem = storeItem[i.itemId + '_' + i.variationId]
				})
			})
			console.log('list', list)
			this.th_printdata = list

		},
	},
	created() {
	},
	mounted() {
		this.getOrdersByOrderId()
		this.getUserAddress()

	},

	methods: {
		...mapActions('order', [
			'getUnprocessOrder',//获取所有商店待处理订单
			'auditOrder',
			'getPrintOrder', //打印订单
			'getOrdersBytrickNo'

		]),
		...mapActions('print', [
			'addPrintNum',

		]),
		...mapMutations('print', [
			'SET_ITEMS',
			'SET_HAS_PRINTED',
			'SET_TTP',
			'SET_HAS_PRINTED_READY',
			'INIT_DATA',
			'FAST_PRINT',
			'UPDATA_PAGE',
			'SENT_PPT'
		]),


		addPrintNum() {
			let list = JSON.parse(localStorage.getItem('unprocessedOrderIds'))
			newOrderApi
				.addPrintNum(list)
				.then(res => {
					if (res.code === 200) {
						console.log('增加了打印次数！')
					} else {
						console.log('增加了打印次数！', res.msg)
					}
				})


			let obj = {
				userId: this.userId,
				orderIds: list.join(),
				createTime: null,
				printType: '3',
			}

			this.insterPrintRecode(obj)

		},

		insterPrintRecode(obj) {
			newOrderApi
				.insertPrintHistory(obj)
				.then(res => {
					if (res.code === 200) {
						console.log('desc', res.data)
					} else {
						this.$message.warning(res.msg)
					}
				})
		},
		getIndex(index, index01) {

			if (index == 0) {
				return Number(index01) + 1;
			} else {
				let num = 0;
				for (let i = index; i > 0; i--) {
					num += this.arr[i - 1].itemsCopy.length
				}
				return Number(num) + Number(index01) + 1;
			}
		},
		calTotal(item) {
			let num = 0
			item.itemsCopy.forEach(p => {
				p.forEach(i => {
					num += i.rate * i.purchaseNum
				})
			})

			return num

		},
		getUserAddress() {
			let params = {
				// cacheData:JSON.stringify(this.formLabelAlign),
				cacheKey: this.userId + '_' + 'Shipper_Address',
				userId: this.userId
			}
			api
				.getUserCache(params)
				.then(res => {
					if (res.code === 200) {

						if (res.data) {
							this.useraddress = JSON.parse(res.data.cacheData)
						} else {
							this.$message.warning(this.$t('other.a937'))
						}

					} else {
						this.$message.warning(res.msg)
					}
				})
		},//获取发货详细信息
		getOrdersByOrderId() {
			let list = JSON.parse(localStorage.getItem('unprocessedOrderIds'))

			newOrderApi
				.getOrderPDF(list)
				.then(res => {
					if (res.code === 200) {
						console.log('获取到订单数据', res.data)
						let list = []
						res.data.forEach((p, index) => {
							p.No = index
							p.barcode = {
								image: null,
							}
							list.push({
								content: p.trackingNo,
								width: 450,
								height: 69
							})
						})

						this.getBarcode(list)
						this.th_printdata = res.data

						this.init()
						console.log('originData', res.data)


					}
				})
		},

		getBarcode(list) {
			sellerPurchaseApi
				.printBarCode(list)
				.then(res => {
					if (res.code === 200) {
						console.log('desc', res.data)
						this.th_printdata.forEach(p => {
							p.barcode = res.data.codes.find(item => item.content == p.trackingNo)
						})
						console.log(this.th_printdata)
					} else {

					}
				})
		},

		init() {



			this.arr = JSON.parse(JSON.stringify(this.th_printdata))
			console.log('arr', this.arr)
			this.arr.forEach(p => {
				p.Tol_price = {

					escrowAmount: 0,
					priceAmount: 0,
					weightAmount: 0

				}
				let list3 = []
				p.itemsCopy = []
				if (p.items.length > 0) {
					p.items.forEach(k => {
						k.ZHUImg = k.image
						if (!k.storeItem || !k.storeItem.children || k.storeItem.component) {//判断items里的每个item是不是套餐，不是才push

							k.cusCode = k.storeItem ? k.storeItem.cusCode : '-'
							k.skuName = k.storeItem ? k.storeItem.skuName : '-'
							k.address = k.storeItem ? k.storeItem.address : '-'
							k.purchaseNum = k.variationQuantityPurchased
							k.rate = 1
							p.itemsCopy.push([k])
							k.isComponent = true
							p.Tol_price.escrowAmount += k.variationQuantityPurchased * k.rate
							p.Tol_price.priceAmount = k.price == null ? 0 : p.priceAmount += k.price
							p.Tol_price.weightAmount += k.weight
						}

						if (k.storeItem && k.storeItem.additions !== null) {
							if (k.storeItem.additions.length > 0) {
								let arr2 = []
								k.storeItem.additions.forEach(p => {
									p.purchaseNum = k.variationQuantityPurchased
									p.ZHUImg = k.ZHUImg
									arr2.push(p)
								})

								list3.push(arr2)
							}
						}


						if (k.storeItem && k.storeItem !== null && k.storeItem.children) {
							if (k.storeItem.children.length > 0 && !k.storeItem.component) {
								k.isComponent = false
								let list2 = []
								k.storeItem.children.forEach(i => {
									i.purchaseNum = k.variationQuantityPurchased
									i.ZHUImg = k.ZHUImg
									list2.push(i)
								})
								list3.push(list2)

							}
						}
					})
				}
				if (list3.length) {
					list3.forEach(i => {
						p.itemsCopy.push(i)
					})


				}

			})



			console.log('arr2', this.arr)

			this.th_printdata.forEach(p => {
				p.genre = 'order'
			})


			this.arr.forEach(p => {
				p.itemsTwo = p.itemsCopy.slice(0, 1)
				p.genre = 'picklist'
			})

			this.th_printdata = [...this.th_printdata, ...this.arr]
			this.th_printdata.sort((a, b) => { return a.No - b.No })

			console.log('852', this.th_printdata)
			// setTimeout(() => {
			// 	this.bindbarcode();
			// this.bindQRCode();
			// },1000)
			this.bindbarcode();

			// this.$nextTick(() => {
			// 	let dome = this.$refs.box
			// 	console.log(dome)
			// 	let h = 1123;
			// 	let d = 0;
			// 	for (let i = 0; i < dome.length; i++) {
			// 		d += dome[i].offsetHeight
			// 		console.log(d, '====>d')
			// 		// if (h - d < 160) {
			// 		// 	// dome[i].style.marginTop =  h - d + 'px';
			// 		// 	dome[i].style.background = 'red';
			// 		// 	d = 0;
			// 		// }
			// 		if(i == 7||i == 6){
			// 			dome[i].style.display = 'none';
			// 		}
			// 	}
			// })
		},

		bindbarcode() {
			this.$nextTick(() => {
				if (this.arr) {
					console.log(this.arr)
					console.log(this.randomArr)
					this.arr.forEach((item, index) => {
						item.itemsCopy.forEach((v, index01) => {
							console.log('barcode_' + (this.getIndex(index, index01)))
							const canvas = document.getElementById('barcode_' + (this.getIndex(index, index01)));
							JsBarcode(canvas, item.orderId, {
								// font: "fantasy",
								fontOptions: "bold",//使文字加粗体或变斜体
								fontSize: 16,
								// width:40,
								height: 50,
								displayValue: false
							})
							// new QRCode(canvas, {
							// 	text: item.orderId,
							// 	width: 120,
							// 	height: 120,
							// 	colorDark: "#000000",
							// 	colorLight: "#ffffff",
							// 	correctLevel: QRCode.CorrectLevel.H
							// });
						})
					})
				}

				console.log(JsBarcode,'==>JsBarcode.')
			})


		},
	}
}
</script>

<style lang="scss" scoped>
.pick-list-box {
	width: 100%;
	min-height: 100vh;
	background: #fff;
	z-index: 99999;
	position: absolute;

}

.top-header {
	position: relative;
	width: 800px;
	text-align: right;
	margin: 0 auto;


}

.pp-wrapper {
	display: flex;

	align-items: center;
}

.pp-name {
	display: inline-block;
	width: 300px !important;
}

.ttp-box {
	margin-bottom: 60px;
	border: 1px solid #000;
}

.pick-list-wrpper {
	width: 100%;
	display: flex;
	justify-content: center;
	font-size: 12px;
	box-sizing: border-box;
	margin: 0 10px;
}

.print-area {
	width: 210mm;
	height: 100%;
	margin-bottom: 200px;
	box-sizing: border-box;
	padding: 30px;
}

.print-desc {
	display: flex;
	flex: 1;

}

.desc-item {
	font-size: 18px;
	/* font-weight: bold; */
	width: 100px;
	word-wrap: break-word;
	padding: 0px 5px;


}

.desc-item-copy {
	font-size: 18px;
	/* font-weight: bold; */
	width: 90px;
	word-wrap: break-word;
	/* margin: 0 20px 0 15px; */
	padding: 0px 5px;


}

.desc-item:nth-child(1) {
	font-size: 18px;
	width: 30px;
}

.desc-item:nth-child(3) {
	font-size: 14px;
	width: 600px;
}

.desc-item-ttp {
	display: inline-block;
	width: 186px;
}

.desc-item-oop {
	display: inline-block;


}

.desc-item-bottom {
	padding: 5px 0;
	border-bottom: 1px solid #DCDFE6
}

.desc-item-bottom:nth-last-child(1) {
	padding: 5px 0;
	border-bottom: none
}



.desc-item-name {
	width: 120px;
	padding: 0px 5px;
	/* font-weight: bold; */
	font-size: 18px;
	word-break: break-all;
	overflow-wrap: break-word;
}

.pic-box {
	width: 120px;
	min-height: 150px;
	/* height: 50px; */
	/* margin: 0 5px; */
}

.barcodeDiv {
	/deep/ img {
		width: 120px;
		height: 120px;
	}
}
</style>
